module.exports = __webpack_public_path__ + "static/media/done-24px.27812f60.svg";